var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g3, _path57, _g4, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g5, _path67, _g6, _path68, _path69, _g7, _path70, _path71, _path72, _g8, _path73, _rect2, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _ellipse, _ellipse2, _ellipse3, _path83, _rect3, _rect4, _rect5, _ellipse4, _path84, _ellipse5, _path85, _g9, _path86, _path87, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 268,
    viewBox: "0 0 438 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 62,
    width: 268,
    height: 206
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.9941,
    y: 62.1133,
    width: 266.361,
    height: 205.057,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6789_88955)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 72,
    width: 35,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.877 72.4629H186.443V97.7809H152.877V72.4629Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.725 88.2886C153.725 88.2886 165.972 77.3256 169.62 75.4948C173.267 73.6647 185.156 71.2916 186.372 73.1217C187.588 74.9525 172.795 87.9705 173.2 89.5979C181.914 89.5979 186.485 89.4289 179.392 92.4796C172.299 95.531 168.248 97.781 163.182 97.781C158.116 97.781 150.28 95.2044 153.725 88.2886",
    fill: "#FFC6A0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.087 129.778L202.45 110.99L176.552 110.268L174.48 128.19C174.45 129.069 173.834 129.824 172.984 130.037C168.968 131.042 166.838 131.394 166.838 131.394C166.838 131.394 169.351 147.057 190.069 147.057C210.787 147.057 211.792 133.918 211.792 133.918C211.792 133.918 208.023 132.62 204.506 131.602C203.688 131.365 203.116 130.63 203.087 129.778",
    fill: "#FFB69C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.682 111.239C170.466 112.459 168.024 107.965 167.217 106.055C165.774 102.641 167.19 98.876 168.845 98.1464C170.36 97.4788 171.849 98.5127 171.849 98.5127C171.849 98.5127 174.346 101.12 174.695 106.386C174.904 109.538 173.682 111.239 173.682 111.239",
    fill: "#FFB594"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.925 112.801C208.004 114.336 210.878 110.106 211.87 108.286C213.644 105.033 212.607 101.146 211.032 100.254C209.592 99.4394 208.007 100.32 208.007 100.32C208.007 100.32 205.265 102.665 204.397 107.87C203.877 110.986 204.925 112.801 204.925 112.801",
    fill: "#FFB594"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.277 77.9686C176.866 77.2987 169.497 87.5206 171.167 101.303C171.988 108.077 171.952 107.942 173.142 114.704C173.683 117.778 179.713 127.983 188.807 128.437C197.31 128.863 203.955 119.533 204.8 116.46C206.58 109.981 206.669 109.837 207.885 103.138C210.368 89.4784 204.589 78.6837 191.179 78.0137L190.277 77.9686Z",
    fill: "#FFC6A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.339 128.87C189.147 128.87 188.951 128.865 188.756 128.855C184.122 128.623 180.499 125.932 178.277 123.716C178.124 123.563 178.124 123.314 178.276 123.161C178.428 123.007 178.675 123.006 178.829 123.159C180.954 125.279 184.408 127.852 188.795 128.071C193.1 128.282 196.714 125.899 198.988 123.857C199.149 123.713 199.395 123.726 199.539 123.887C199.683 124.049 199.67 124.297 199.509 124.442C197.228 126.49 193.65 128.87 189.339 128.87",
    fill: "#DB836E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.146 78.3278C191.141 78.3278 191.136 78.3278 191.132 78.3278L190.23 78.2827C190.072 78.2743 189.95 78.1397 189.957 77.9806C189.966 77.8215 190.099 77.6999 190.258 77.7068L191.16 77.7519C191.318 77.7596 191.44 77.8949 191.432 78.054C191.425 78.2085 191.298 78.3278 191.146 78.3278",
    fill: "#EA967D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.007 105.094C198.998 105.094 198.989 105.094 198.98 105.093C198.693 105.079 198.471 104.833 198.486 104.545C198.51 104.055 198.388 103.574 198.153 103.226C197.944 102.917 197.67 102.74 197.379 102.725C197.096 102.711 196.797 102.86 196.559 103.146C196.29 103.47 196.121 103.936 196.097 104.426C196.082 104.714 195.839 104.94 195.55 104.922C195.263 104.907 195.041 104.662 195.055 104.374C195.091 103.651 195.341 102.976 195.759 102.475C196.211 101.931 196.806 101.649 197.43 101.68C198.047 101.711 198.624 102.06 199.015 102.637C199.381 103.178 199.563 103.874 199.527 104.597C199.513 104.877 199.283 105.094 199.007 105.094",
    fill: "#5C2552"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.024 104.295C183.016 104.295 183.007 104.295 182.998 104.295C182.71 104.28 182.489 104.035 182.503 103.746C182.55 102.792 182.044 101.959 181.396 101.927C180.731 101.898 180.162 102.673 180.115 103.626C180.1 103.915 179.865 104.139 179.567 104.123C179.28 104.109 179.058 103.863 179.073 103.575C179.149 102.029 180.18 100.815 181.448 100.882C182.681 100.943 183.622 102.251 183.545 103.798C183.531 104.078 183.3 104.295 183.024 104.295",
    fill: "#5C2552"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.168 111.864C191.162 111.864 191.155 111.864 191.149 111.864L188.081 111.711C187.866 111.7 187.699 111.516 187.709 111.299C187.721 111.083 187.913 110.916 188.12 110.927L190.787 111.06L190.996 102.133C190.998 102.058 191.022 101.986 191.063 101.923L192.957 99.0941C193.077 98.9137 193.32 98.8655 193.499 98.9871C193.679 99.1079 193.726 99.3519 193.605 99.5316L191.775 102.266L191.559 111.481C191.557 111.587 191.512 111.688 191.434 111.76C191.361 111.827 191.266 111.864 191.168 111.864",
    fill: "#DB836E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.573 120.353C190.566 120.353 190.56 120.353 190.553 120.352L187.438 120.197C187.222 120.186 187.056 120.002 187.067 119.785C187.078 119.569 187.271 119.401 187.477 119.413L190.592 119.568C190.807 119.579 190.973 119.763 190.963 119.979C190.953 120.19 190.779 120.353 190.573 120.353",
    fill: "#DB836E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.25 114.308V114.308C193.085 117.353 186.866 118.895 183.941 113.807L194.25 114.308",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.682 114.235C185.93 115.976 187.772 116.871 189.822 116.71C191.457 116.581 192.936 115.77 193.632 114.671L184.682 114.235ZM189.344 117.513C186.969 117.513 184.898 116.256 183.603 114.002C183.531 113.878 183.534 113.725 183.608 113.602C183.682 113.479 183.815 113.412 183.96 113.414L194.27 113.917C194.395 113.923 194.51 113.988 194.578 114.094C194.647 114.2 194.661 114.332 194.616 114.45C193.985 116.096 192.083 117.319 189.883 117.492C189.702 117.506 189.522 117.513 189.344 117.513V117.513Z",
    fill: "#DB836E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.427 87.2658C174.331 90.9895 174.299 94.7904 173.982 95.7494C173.897 96.0056 172.755 97.6369 172.755 97.6369L171.546 104.075C171.546 104.075 169.556 95.4022 169.608 81.5423C169.615 79.9202 170.645 78.474 172.179 77.9639C173.438 77.5456 175.19 76.9169 177.488 75.9954C185.946 72.6029 192.518 73.152 192.518 73.152C209.599 74.2112 211.884 86.254 209.186 98.6502C208.618 101.262 208.234 102.986 207.427 105.867L206.496 99.3224L204.876 97.3394C204.876 97.3394 204.908 93.2869 204.284 88.7242L175.427 87.2658Z",
    fill: "#5C2552"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.829 98.8237C180.767 98.8237 178.662 98.3128 178.086 98.1621L176.543 98.6065C176.268 98.686 175.977 98.5254 175.897 98.2478C175.818 97.9702 175.978 97.6803 176.255 97.6008L177.938 97.1159C178.031 97.0899 178.128 97.0892 178.221 97.1152C179.78 97.5488 184.175 98.3877 185.772 97.07C185.995 96.8865 186.323 96.9194 186.506 97.1419C186.689 97.3652 186.657 97.6949 186.434 97.8784C185.566 98.595 184.207 98.8237 182.829 98.8237",
    fill: "#5C2552"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.844 99.9482C202.78 99.9482 202.714 99.9359 202.651 99.9107L201.139 99.3073C200.048 99.4006 194.517 99.8097 193.022 98.6297C192.795 98.4515 192.756 98.1227 192.934 97.8948C193.112 97.6684 193.439 97.6286 193.666 97.8068C194.603 98.5456 198.765 98.4729 201.17 98.2542C201.251 98.2466 201.334 98.2588 201.41 98.2886L203.036 98.9387C203.304 99.0457 203.434 99.3501 203.328 99.6186C203.247 99.8235 203.051 99.9482 202.844 99.9482",
    fill: "#5C2552"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.611 259.828C175.478 259.828 175.36 259.73 175.339 259.594C175.315 259.443 175.419 259.301 175.569 259.278C175.79 259.243 175.93 259.176 175.955 259.093C176.027 258.85 175.556 258.256 175.203 257.937C171.499 255.4 168.069 248.523 169.41 243.822C171.891 235.122 166.66 231.62 166.607 231.585C166.479 231.503 166.442 231.331 166.524 231.203C166.607 231.075 166.777 231.037 166.905 231.12C166.962 231.157 172.531 234.885 169.94 243.974C168.659 248.462 171.958 255.046 175.543 257.503C175.76 257.695 176.684 258.573 176.484 259.251C176.392 259.56 176.113 259.753 175.654 259.825C175.639 259.827 175.626 259.828 175.611 259.828",
    fill: "#EA967D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.513 260.712C179.396 260.712 179.289 260.638 179.251 260.521C179.204 260.376 179.284 260.22 179.428 260.173C179.716 260.079 180.066 259.913 180.107 259.654C180.172 259.251 179.573 258.643 179.18 258.355C173.887 253.277 173.972 246.258 173.973 246.189C173.977 246.036 174.124 245.93 174.255 245.918C174.406 245.921 174.528 246.047 174.524 246.199C174.523 246.267 174.448 253.05 179.533 257.931C179.636 258.004 180.789 258.875 180.652 259.74C180.583 260.171 180.228 260.494 179.597 260.699C179.569 260.708 179.541 260.712 179.513 260.712",
    fill: "#EA967D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.619 260.301C177.497 260.301 177.387 260.221 177.353 260.099C177.312 259.952 177.398 259.799 177.545 259.758C177.743 259.703 177.986 259.602 178.024 259.437C178.083 259.182 177.72 258.756 177.546 258.601C171.525 253.862 171.494 246.117 171.494 246.039C171.495 245.887 171.618 245.764 171.77 245.764H171.771C171.923 245.764 172.047 245.889 172.046 246.042C172.046 246.117 172.082 253.597 177.899 258.177C177.993 258.26 178.709 258.918 178.561 259.562C178.482 259.907 178.19 260.152 177.693 260.291C177.667 260.298 177.643 260.301 177.619 260.301",
    fill: "#EA967D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.379 96.5131L157.597 86.4785C157.597 86.4785 138.412 93.4387 124.632 97.778C108.43 102.88 95.3944 109.318 92.2079 121.26C87.8283 137.671 152.193 164.179 152.193 164.179C164.757 162.552 165.838 136.923 146.789 131.228C141.925 127.16 126.793 121.735 126.793 121.735C126.793 121.735 133.93 116.149 142.242 109.442C152.253 101.364 161.379 96.5131 161.379 96.5131",
    fill: "#FFC6A0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.341 137.367C225.341 137.367 214.47 153.729 228.119 181.13C235.163 194.182 247.724 214.556 255.14 213.945C261.755 213.4 264.496 195.132 261.083 186.174C257.671 177.216 243.034 155.199 243.034 155.199C243.034 155.199 239.738 139.364 225.341 137.367",
    fill: "#FFC6A0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 146,
    width: 87,
    height: 69
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.562 146.699H332.681V214.345H246.562V146.699Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.286 196.976C247.286 196.976 248.498 189.04 260.785 182.128C278.496 172.165 295.59 156.15 295.59 156.15C295.59 156.15 302.684 148.026 307.511 148.717C312.337 149.409 317.428 148.289 320.876 146.905C324.323 145.52 322.953 151.528 312.116 153.159C318.709 155.787 326.836 155.787 330.81 153.612C334.926 151.359 332.187 162.067 323.224 164.489C314.26 166.911 301.708 167.03 301.708 167.03C301.708 167.03 270.674 213.94 256.68 214.338C242.686 214.736 247.286 196.976 247.286 196.976",
    fill: "#FFC6A0"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.115 162.235C317.102 162.235 315.178 161.836 313.687 160.918C306.021 156.197 301.384 160.174 301.191 160.345C301.076 160.447 300.903 160.435 300.801 160.321C300.701 160.207 300.712 160.033 300.825 159.931C300.875 159.887 305.948 155.502 313.975 160.446C317.939 162.888 325.143 161.465 328.464 158.658C328.706 158.5 329.799 157.842 330.393 158.218C330.665 158.389 330.775 158.711 330.721 159.173C330.703 159.326 330.564 159.434 330.415 159.416C330.263 159.398 330.156 159.261 330.173 159.109C330.199 158.886 330.173 158.732 330.1 158.686C329.885 158.551 329.2 158.841 328.789 159.103C326.592 160.962 322.711 162.235 319.115 162.235",
    fill: "#EA967D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.575 157.672C319 157.672 317.219 157.151 317.184 157.14C317.039 157.096 316.956 156.942 317 156.796C317.044 156.649 317.199 156.567 317.343 156.611C317.408 156.63 323.897 158.524 329.946 154.915C330.044 154.835 331.19 153.953 331.983 154.319C332.378 154.5 332.592 154.93 332.62 155.594C332.627 155.747 332.508 155.877 332.356 155.883C332.193 155.885 332.076 155.77 332.07 155.618C332.057 155.315 331.992 154.931 331.754 154.821C331.384 154.652 330.639 155.068 330.258 155.37C327.191 157.201 324.023 157.672 321.575 157.672",
    fill: "#EA967D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.544 159.975C318.11 159.975 316.412 159.507 316.376 159.497C316.23 159.456 316.145 159.303 316.186 159.156C316.227 159.009 316.38 158.924 316.527 158.965C316.598 158.986 323.787 160.957 329.743 156.561C329.849 156.493 330.673 155.977 331.251 156.293C331.561 156.462 331.718 156.81 331.718 157.328C331.718 157.481 331.594 157.605 331.442 157.605C331.29 157.605 331.166 157.481 331.166 157.328C331.166 157.122 331.135 156.86 330.988 156.779C330.757 156.653 330.261 156.885 330.056 157.016C326.821 159.405 323.234 159.975 320.544 159.975",
    fill: "#EA967D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.685 277.95L243.17 484.157C233.029 491.903 218.722 486.522 218.722 486.522L194.952 296.638C194.692 294.557 192.929 292.995 190.839 292.995C188.745 292.995 186.98 294.561 186.723 296.647L163.421 486.157C150.085 490.282 139.031 484.702 139.031 484.702L152.93 277.137C151.579 274.153 153.466 273.105 153.466 273.105L156.821 242.502L223.896 242.307L227.144 273.069C227.144 273.069 228.732 273.769 227.685 277.95",
    fill: "#6297CC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.327 128.652C168.754 130.529 171.647 138.754 171.647 138.754C176.486 152.839 168.243 171.341 157.154 169.115C152.088 168.098 144.894 163.361 138.206 159.903C134.25 157.857 130.307 158.349 130.847 155.637L125.713 152.925C130.847 137.466 133.819 124.312 133.819 124.312C133.819 124.312 135.634 124.947 138.152 125.33C138.152 125.33 140.935 123.227 143.367 125.804C144.988 127.296 157.327 128.652 157.327 128.652",
    fill: "#E5E3EA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.96 243.9C187.071 250.509 156.611 243.962 156.611 243.962C151.535 237.381 155.822 226.546 155.822 226.546C150.965 179.263 147.938 132.245 147.938 132.245C147.938 132.245 148.68 126.438 156.786 128.065C160.27 128.764 163.744 128.991 171.704 129.902C171.945 129.93 172.186 131.354 172.323 131.553C173.299 132.977 177.795 138.437 189.283 138.437C199.257 138.437 204.632 133.301 206.039 131.97C206.257 131.764 206.867 131.776 207.072 131.869C209.101 132.789 209.769 132.982 212.966 133.623C219.817 134.999 224.677 135.66 225.689 135.883C226.795 136.127 227.642 136.621 228.771 136.963C228.771 136.963 225.688 194.42 223.62 219.606C223.522 220.804 224.368 222.42 224.318 224.483C224.265 226.747 223.486 227.725 223.486 229.935C223.486 229.935 227.94 238.333 223.96 243.9",
    fill: "#E5E3EA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.975 189.417C231.975 189.417 231.085 188.045 229.76 185.912C229.368 185.281 228.543 185.155 228.087 184.407C227.702 183.775 227.523 182.45 227.108 181.755C224.339 177.118 221.231 171.373 219.558 167.177C215.358 156.639 216.001 136.669 226.544 136.669C226.544 136.669 237.685 135.711 245.403 156.513C245.831 157.667 246.519 159.094 247.316 160.591C247.97 161.822 249.635 162.27 250.35 163.485C251 164.588 250.702 166.47 251.269 167.384C252.431 169.258 253.286 170.557 253.286 170.557C253.286 170.557 240.76 176.942 231.975 189.417",
    fill: "#E5E3EA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.537 139.469C174.468 139.469 174.397 139.451 174.334 139.412C172.995 138.59 171.778 137.629 170.715 136.555C170.563 136.402 170.564 136.153 170.717 136.001C170.87 135.848 171.118 135.849 171.27 136.002C172.288 137.031 173.457 137.953 174.742 138.742C174.926 138.855 174.984 139.097 174.871 139.282C174.797 139.403 174.669 139.469 174.537 139.469",
    fill: "#E4EBF7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.665 193.483C249.642 193.483 249.618 193.481 249.594 193.476C249.399 193.437 249.273 193.247 249.312 193.051C250.507 187.051 259.116 182.762 259.481 182.582C259.66 182.493 259.875 182.569 259.963 182.747C260.051 182.927 259.977 183.143 259.798 183.231C259.711 183.273 251.143 187.544 250.018 193.193C249.984 193.365 249.834 193.483 249.665 193.483",
    fill: "#EA967D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.067 260.376C189.882 260.376 189.733 260.226 189.733 260.041V254.933C189.733 254.748 189.882 254.598 190.067 254.598C190.251 254.598 190.4 254.748 190.4 254.933V260.041C190.4 260.226 190.251 260.376 190.067 260.376",
    fill: "#4670B2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.199 284.736C190.028 284.736 189.883 284.606 189.867 284.432C189.85 284.248 189.985 284.084 190.168 284.067C190.229 284.061 196.182 283.468 196.325 280.456C196.711 272.307 196.716 255.105 196.716 254.933C196.716 254.748 196.865 254.598 197.049 254.598C197.234 254.598 197.384 254.748 197.384 254.933C197.384 255.105 197.379 272.324 196.992 280.487C196.821 284.079 190.499 284.709 190.23 284.734C190.219 284.736 190.21 284.736 190.199 284.736",
    fill: "#4670B2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.067 292.595C190.013 292.595 189.959 292.582 189.91 292.555L172.294 283.125C172.131 283.038 172.07 282.835 172.157 282.672C172.243 282.509 172.446 282.447 172.608 282.534L189.733 291.701V264.56C189.733 264.375 189.882 264.225 190.067 264.225C190.251 264.225 190.4 264.375 190.4 264.56V292.26C190.4 292.377 190.339 292.486 190.239 292.547C190.186 292.578 190.126 292.595 190.067 292.595",
    fill: "#4670B2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.835 272.851C225.803 272.851 225.771 272.846 225.738 272.836C218.882 270.726 218.47 253.935 218.455 253.221C218.452 253.036 218.598 252.883 218.783 252.879C218.983 252.883 219.12 253.023 219.123 253.208C219.126 253.378 219.536 270.227 225.933 272.195C226.11 272.25 226.209 272.437 226.155 272.614C226.11 272.758 225.978 272.851 225.835 272.851",
    fill: "#4670B2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.279 272.591C154.152 272.591 154.03 272.517 153.975 272.392C153.899 272.224 153.975 272.025 154.143 271.95C160.76 268.982 160.475 254.401 160.471 254.254C160.466 254.069 160.612 253.915 160.796 253.91C160.973 253.903 161.134 254.053 161.138 254.237C161.154 254.856 161.437 269.412 154.416 272.562C154.372 272.582 154.325 272.591 154.279 272.591",
    fill: "#4670B2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.43 142.995C184.079 142.995 179.453 141.999 175.683 140.034C175.55 139.965 175.499 139.802 175.568 139.669C175.635 139.536 175.797 139.484 175.931 139.553C179.625 141.477 184.166 142.453 189.43 142.453C198.483 142.453 204.025 138.741 206.524 136.528C206.636 136.43 206.806 136.44 206.905 136.553C207.003 136.665 206.992 136.836 206.881 136.935C204.326 139.198 198.66 142.995 189.43 142.995",
    fill: "#C2C0CC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.905 193.91C224.899 193.91 224.892 193.91 224.886 193.909C224.737 193.899 224.625 193.769 224.635 193.62L226.985 160.223C226.994 160.074 227.124 159.958 227.273 159.972C227.421 159.983 227.533 160.112 227.523 160.261L225.174 193.658C225.164 193.801 225.045 193.91 224.905 193.91",
    fill: "#C2C0CC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.002 188.655C152.868 188.655 152.752 188.555 152.735 188.418L149.682 163.812C149.663 163.663 149.768 163.528 149.916 163.51C150.063 163.492 150.198 163.597 150.217 163.745L153.271 188.351C153.289 188.499 153.184 188.635 153.036 188.653C153.024 188.655 153.014 188.655 153.002 188.655",
    fill: "#C2C0CC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.791 172.049C243.705 172.049 243.62 172.008 243.568 171.931C243.484 171.807 243.516 171.638 243.64 171.555C245.812 170.075 248.035 168.861 250.247 167.948C250.385 167.891 250.543 167.957 250.599 168.096C250.656 168.234 250.59 168.392 250.452 168.449C248.275 169.348 246.085 170.544 243.942 172.003C243.897 172.034 243.843 172.049 243.791 172.049",
    fill: "#C2C0CC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.385 185.56C230.334 185.56 230.283 185.546 230.237 185.517C230.113 185.435 230.077 185.267 230.159 185.142C230.203 185.073 234.673 178.242 241.949 172.765C242.067 172.675 242.238 172.7 242.326 172.819C242.416 172.939 242.391 173.109 242.272 173.198C235.072 178.618 230.655 185.369 230.611 185.437C230.559 185.517 230.473 185.56 230.385 185.56",
    fill: "#C2C0CC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.038 167.192C228.017 167.192 227.996 167.19 227.975 167.185C227.829 167.149 227.74 167.003 227.775 166.858C230.468 155.662 227.805 145.875 227.778 145.778C227.737 145.633 227.822 145.484 227.965 145.444C228.111 145.403 228.258 145.488 228.298 145.632C228.326 145.731 231.026 155.653 228.3 166.985C228.271 167.109 228.16 167.192 228.038 167.192",
    fill: "#C2C0CC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.76 162.62C149.634 162.62 149.522 162.532 149.495 162.403C147.43 152.306 148.849 139.441 148.864 139.312C148.88 139.164 149.013 139.058 149.162 139.074C149.31 139.091 149.417 139.225 149.4 139.374C149.386 139.501 147.977 152.282 150.025 162.294C150.055 162.441 149.96 162.584 149.815 162.614C149.796 162.618 149.778 162.62 149.76 162.62",
    fill: "#C2C0CC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.978 205.698C184.849 205.698 184.734 205.603 184.712 205.47C184.689 205.322 184.788 205.183 184.936 205.159C185.08 205.136 199.44 202.741 207.123 196.571C207.238 196.478 207.408 196.496 207.502 196.614C207.595 196.73 207.576 196.901 207.459 196.995C199.666 203.253 185.167 205.67 185.022 205.694C185.007 205.697 184.993 205.698 184.978 205.698",
    fill: "#C2C0CC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.115 211.643C183.078 211.643 176.06 210.817 175.943 210.802C175.795 210.785 175.689 210.65 175.707 210.501C175.725 210.353 175.863 210.248 176.007 210.265C176.203 210.288 195.658 212.58 206.828 209.486C206.975 209.447 207.12 209.532 207.16 209.676C207.2 209.819 207.115 209.969 206.972 210.009C202.429 211.266 196.539 211.643 191.115 211.643",
    fill: "#C2C0CC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.608 169.898C302.248 170.375 301.598 170.521 301.065 170.253C299.437 169.436 293.369 165.575 292.207 158.095C292.184 157.946 292.274 157.798 292.383 157.695C293.108 157.011 293.776 156.423 294.225 156.038C294.48 155.818 294.873 155.944 294.954 156.272C295.469 158.334 297.428 164.3 303.335 166.96C303.83 167.183 304.008 167.798 303.723 168.261C303.443 168.714 303.064 169.293 302.608 169.898",
    fill: "#192064"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.032 166.237C299.032 166.501 298.819 166.715 298.555 166.715C298.291 166.715 298.078 166.501 298.078 166.237C298.078 165.972 298.291 165.758 298.555 165.758C298.819 165.758 299.032 165.972 299.032 166.237",
    fill: "#C1C4D6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300.94 167.528C300.94 167.792 300.727 168.006 300.463 168.006C300.2 168.006 299.986 167.792 299.986 167.528C299.986 167.263 300.2 167.049 300.463 167.049C300.727 167.049 300.94 167.263 300.94 167.528",
    fill: "#C1C4D6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.814 252.183C155.814 252.183 189.998 258.4 224.661 252.183C224.368 247.468 224.029 243.9 224.029 243.9C224.029 243.9 195.221 248.676 156.622 244.005C156.161 248.419 155.814 252.183 155.814 252.183",
    fill: "#5C2552"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.016 246.239V255.446C181.016 256.266 181.654 256.943 182.471 256.973C187.03 257.14 191.933 257.169 197.109 256.988C197.926 256.96 198.58 256.281 198.58 255.459V246.262C198.58 245.403 197.881 244.717 197.026 244.74C192.571 244.857 187.738 244.865 182.588 244.717C181.73 244.693 181.016 245.378 181.016 246.239",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.1 247.985V253.751C183.1 254.404 183.608 254.941 184.257 254.962C187.672 255.072 191.342 255.09 195.213 254.973C195.864 254.953 196.387 254.414 196.387 253.76V248C196.387 247.322 195.839 246.779 195.163 246.794C191.822 246.871 188.2 246.877 184.342 246.78C183.665 246.763 183.1 247.305 183.1 247.985",
    fill: "#5C2552"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.118 154.28C131.094 154.28 131.07 154.277 131.046 154.27C130.902 154.23 130.817 154.081 130.858 153.937C133.661 143.752 136.902 130.482 136.935 130.349C136.971 130.204 137.119 130.115 137.261 130.15C137.406 130.186 137.495 130.333 137.459 130.478C137.426 130.611 134.184 143.889 131.377 154.081C131.345 154.201 131.236 154.28 131.118 154.28",
    fill: "#C2C0CC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.456 165.225C149.358 165.225 149.265 165.172 149.217 165.079C146.117 159.125 143.021 151.761 142.99 151.687C142.932 151.549 142.996 151.39 143.134 151.332C143.27 151.274 143.429 151.339 143.488 151.476C143.518 151.55 146.606 158.894 149.694 164.829C149.764 164.961 149.713 165.124 149.581 165.194C149.54 165.215 149.498 165.225 149.456 165.225",
    fill: "#C2C0CC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.853 131.052C110.755 131.052 110.659 131.05 110.564 131.046C110.365 131.036 110.212 130.867 110.221 130.668C110.23 130.468 110.394 130.307 110.598 130.324C116.072 130.577 125.651 122.358 125.748 122.275C125.897 122.145 126.125 122.161 126.255 122.313C126.385 122.464 126.368 122.692 126.217 122.823C125.823 123.164 116.627 131.052 110.853 131.052",
    fill: "#EA967D"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9638 51.291L53.7715 83.916H59.9336L70.127 51.291H63.9638Z",
    fill: "#CED0DB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 55,
    width: 13,
    height: 26
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 55.1172H50.0248V80.6445H38V55.1172Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4328 55.1172H42.7832H38.5922C38.2651 55.1172 38 55.3863 38 55.7184V59.9732V75.7885V80.0433C38 80.3754 38.2651 80.6445 38.5922 80.6445H42.7832H49.4328C49.7599 80.6445 50.025 80.3754 50.025 80.0433V76.3898C50.025 76.0577 49.7599 75.7885 49.4328 75.7885H42.7832V59.9732H49.4328C49.7599 59.9732 50.025 59.704 50.025 59.3729V55.7184C50.025 55.3863 49.7599 55.1172 49.4328 55.1172",
    fill: "#E4E6EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 55,
    width: 13,
    height: 26
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2891 55.1172H86.3136V80.6445H74.2891V55.1172Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7218 55.1172H81.5309H74.8813C74.5541 55.1172 74.2891 55.3863 74.2891 55.7184V59.3729C74.2891 59.704 74.5541 59.9732 74.8813 59.9732H81.5309V75.7885H74.8813C74.5541 75.7885 74.2891 76.0577 74.2891 76.3898V80.0433C74.2891 80.3754 74.5541 80.6445 74.8813 80.6445H81.5309H85.7218C86.049 80.6445 86.3141 80.3754 86.3141 80.0433V76.3898V59.3729V55.7184C86.3141 55.3863 86.049 55.1172 85.7218 55.1172",
    fill: "#E4E6EF"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.085 232.04H332.951V190.051C332.951 186.709 335.653 184 338.986 184H339.05C342.383 184 345.085 186.709 345.085 190.051V232.04Z",
    fill: "#5BA02E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.443 242.248H339.211V220.201C339.211 216.93 341.867 214.277 345.143 214.277H345.511C348.787 214.277 351.443 216.93 351.443 220.201V242.248Z",
    fill: "#92C110"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.244 231.834H321.012V208.002C321.012 204.73 323.657 202.078 326.92 202.078H327.335C330.598 202.078 333.244 204.73 333.244 208.002V231.834Z",
    fill: "#92C110"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.379 267C318.065 267 317 265.986 317 264.734V233.266C317 232.014 318.065 231 319.379 231H352.621C353.935 231 355 232.014 355 233.266V264.734C355 265.986 353.935 267 352.621 267H319.379Z",
    fill: "#CAD5EE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.123 193.151C337.123 193.809 336.589 194.341 335.93 194.341C335.271 194.341 334.736 193.809 334.736 193.151C334.736 192.494 335.271 191.961 335.93 191.961C336.589 191.961 337.123 192.494 337.123 193.151",
    fill: "#92C110"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.387 205.35C343.387 206.008 342.852 206.541 342.193 206.541C341.534 206.541 341 206.008 341 205.35C341 204.693 341.534 204.16 342.193 204.16C342.852 204.16 343.387 204.693 343.387 205.35",
    fill: "#92C110"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.891 211.302C324.891 211.959 324.356 212.492 323.697 212.492C323.038 212.492 322.504 211.959 322.504 211.302C322.504 210.644 323.038 210.111 323.697 210.111C324.356 210.111 324.891 210.644 324.891 211.302",
    fill: "#5BA02E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.857 223.501C330.857 224.158 330.323 224.691 329.664 224.691C329.005 224.691 328.471 224.158 328.471 223.501C328.471 222.843 329.005 222.311 329.664 222.311C330.323 222.311 330.857 222.843 330.857 223.501",
    fill: "#5BA02E"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.567708
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 360,
    y: 159,
    width: 36,
    height: 9
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360 159.102H395.317V167.428H360V159.102Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.157 167.428L391.165 167.416C393.459 167.415 395.318 165.553 395.317 163.257C395.316 160.961 393.456 159.101 391.161 159.102L364.153 159.113C361.858 159.114 359.999 160.977 360 163.273C360.001 165.568 361.862 167.429 364.157 167.428",
    fill: "#E4E6EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 370,
    y: 175,
    width: 36,
    height: 9
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.258 175.459H405.61V183.751H370.258V175.459Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.419 183.751L401.453 183.74C403.75 183.739 405.611 181.884 405.61 179.597C405.609 177.311 403.747 175.458 401.45 175.459L374.416 175.47C372.118 175.471 370.257 177.325 370.258 179.613C370.259 181.899 372.122 183.752 374.419 183.751",
    fill: "#E4E6EF"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.73 167.477V167.475L390.961 167.469C388.676 167.47 386.826 169.31 386.827 171.577C386.827 173.845 388.68 175.682 390.964 175.681L376.734 175.688V175.687C379.002 175.666 380.833 173.835 380.832 171.579C380.831 169.324 378.998 167.496 376.73 167.477",
    fill: "#E4E6EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 209,
    width: 10,
    height: 10
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0039 209.314H67.086V218.396H58.0039V209.314Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0619 214.319C66.8059 216.813 64.5763 218.628 62.0818 218.372C59.5865 218.116 57.7713 215.887 58.0281 213.391C58.2841 210.897 60.5138 209.082 63.0083 209.339C65.5027 209.595 67.3179 211.824 67.0619 214.319",
    fill: "#E4E6EF"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2315 197.692C95.9735 200.2 93.7258 202.025 91.2111 201.768C88.6956 201.511 86.8658 199.268 87.1239 196.76C87.3827 194.251 89.6304 192.426 92.1451 192.684C94.6597 192.941 96.4895 195.184 96.2315 197.692",
    fill: "#E4E6EF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1318 196.032C36.874 198.541 34.6255 200.365 32.1103 200.108C29.5958 199.85 27.7658 197.608 28.0243 195.1C28.2821 192.591 30.5306 190.767 33.0451 191.024C35.5603 191.281 37.3903 193.524 37.1318 196.032",
    fill: "#E4E6EF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 202,
    width: 11,
    height: 11
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.092 202.699H122.002V212.498H112.092V202.699Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.976 208.099C121.696 210.79 119.264 212.748 116.541 212.472C113.819 212.195 111.839 209.79 112.118 207.098C112.398 204.407 114.831 202.449 117.553 202.725C120.275 203.002 122.255 205.407 121.976 208.099",
    fill: "#E4E6EF"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6063 214.245L62.4946 214.175L32.9941 195.529L33.2289 195.15L62.6186 213.727L92.3862 196.89L92.484 196.929L117.897 207.008L117.735 207.423L92.4193 197.383L62.6063 214.245Z",
    fill: "#E4E6EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 252.062,
    y: 34.4883,
    width: 133.039,
    height: 97.314,
    rx: 3.88851,
    fill: "#E2E7F2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.791 122.122C291.057 122.122 290.461 121.526 290.461 120.792V53.9632C290.461 53.2284 291.057 52.6328 291.791 52.6328H372.746C373.481 52.6328 374.077 53.2285 374.077 53.9632V121.053C374.077 121.643 373.586 122.122 372.98 122.122H291.791Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.708 105.255C298.102 105.255 297.611 104.776 297.611 104.186V60.7644C297.611 60.1739 298.102 59.6953 298.708 59.6953H366.211C366.817 59.6953 367.308 60.1739 367.308 60.7644V104.186C367.308 104.776 366.817 105.255 366.211 105.255H298.708Z",
    fill: "#CED7EC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.146 65.9753H302.36C301.99 65.9753 301.689 65.6826 301.689 65.3216C301.689 64.9606 301.99 64.668 302.36 64.668H307.146C307.516 64.668 307.816 64.9606 307.816 65.3216C307.816 65.6826 307.516 65.9753 307.146 65.9753",
    fill: "#B2BED9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.222 69.112H302.436C302.066 69.112 301.766 68.8194 301.766 68.4583C301.766 68.0973 302.066 67.8047 302.436 67.8047H307.222C307.592 67.8047 307.892 68.0973 307.892 68.4583C307.892 68.8194 307.592 69.112 307.222 69.112",
    fill: "#B2BED9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.613 93.2214C304.867 93.2214 302.941 84.26 313.926 84.26C324.912 84.26 324.34 92.2711 332.908 92.2711C341.609 92.2711 341.034 69.2617 349.37 69.2617C358.169 69.2617 356.183 90.1115 367.144 90.1115V104.241C367.144 104.832 366.652 105.311 366.046 105.311L298.709 105.254C298.104 105.253 297.613 104.775 297.613 104.185L297.613 93.2214Z",
    fill: "#393D65"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M297.365 96.6857C308.326 96.6857 306.772 72.1797 313.836 72.1797C320.564 72.1797 318.543 96.6857 332.478 96.6857C341.046 96.6857 343.741 86.6961 349.793 86.6961C355.846 86.6961 359.889 96.6857 367.143 96.6857",
    stroke: "white",
    strokeWidth: 0.528333
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M298.346 111.594H365.956",
    stroke: "#E4E6EF",
    strokeWidth: 0.997795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M298.346 116.108H355.151",
    stroke: "#E4E6EF",
    strokeWidth: 0.997795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M255.626 30H381.471C383.44 30 385.035 31.5556 385.035 33.4745V43.8284H252.062V33.4745C252.062 31.5556 253.658 30 255.626 30Z",
    fill: "#393D65"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.68,
    cy: 36.9135,
    rx: 2.54349,
    ry: 2.4799,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.18,
    cy: 36.9135,
    rx: 2.54349,
    ry: 2.4799,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.68,
    cy: 36.9135,
    rx: 2.54349,
    ry: 2.4799,
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M296.234 85.8818L294.598 84.6816L296.234 83.4844L297.87 84.6816L296.234 85.8818V85.8818Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 261.529,
    y: 79.6641,
    width: 19.0353,
    height: 4.68619,
    rx: 1.04958,
    fill: "#B2BED9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 261.529,
    y: 88.6875,
    width: 19.0353,
    height: 4.54431,
    rx: 1.03365,
    fill: "#B2BED9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 261.529,
    y: 97.5254,
    width: 19.0353,
    height: 4.54431,
    rx: 1.03365,
    fill: "#B2BED9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.048,
    cy: 62.7477,
    rx: 9.50281,
    ry: 9.26524,
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M271.047 72.0127C273.786 72.0142 276.385 70.8345 278.147 68.7901C276.759 66.2201 274.024 64.6113 271.045 64.6113C268.066 64.6113 265.332 66.2201 263.943 68.7901C265.706 70.8349 268.307 72.0146 271.047 72.0127V72.0127Z",
    fill: "#393D65"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.097,
    cy: 61.4944,
    rx: 3.57395,
    ry: 3.4846,
    fill: "#393D65"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_6789_88955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 355,
    y: 0,
    width: 60,
    height: 60
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355 0H415V60H355V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_6789_88955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385 0C368.431 0 355 13.4314 355 30C355 46.5685 368.431 60 385 60C401.569 60 415 46.5685 415 30C415 13.4314 401.569 0 385 0",
    fill: "#597EF7"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.083 18.2287C393.662 19.645 394.471 21.5874 394.471 24.0154C394.471 25.9982 393.945 27.6574 392.974 28.9522C392.609 29.3974 391.476 30.4496 389.534 32.1086C388.806 32.7561 388.239 33.4441 387.875 34.1724C387.43 34.9818 387.227 35.872 387.227 36.8837V37.844C387.227 38.2451 386.902 38.5704 386.501 38.5704H383.624C383.223 38.5704 382.897 38.2451 382.897 37.844V36.8837C382.897 35.3864 383.14 34.0915 383.666 33.0393C384.233 31.9064 385.771 30.2472 388.28 28.0216L388.968 27.2528C389.696 26.322 390.06 25.3508 390.06 24.2986C390.06 22.8823 389.655 21.7897 388.887 20.9803C388.077 20.1711 386.944 19.7664 385.487 19.7664C383.666 19.7664 382.331 20.3329 381.522 21.466C380.889 22.3101 380.531 23.4902 380.448 24.9534C380.426 25.3361 380.106 25.634 379.723 25.634H376.885C376.471 25.634 376.138 25.2874 376.159 24.8735C376.295 22.2811 377.142 20.2247 378.73 18.6738C380.429 16.9338 382.776 16.084 385.73 16.084C388.361 16.084 390.465 16.7719 392.083 18.2287",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.417 45.1588H384.345C383.458 45.1588 382.738 44.4392 382.738 43.5516V42.4802C382.738 41.5926 383.458 40.873 384.345 40.873H385.417C386.304 40.873 387.024 41.5926 387.024 42.4802V43.5516C387.024 44.4392 386.304 45.1588 385.417 45.1588",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 267,
    width: 438,
    height: 1,
    fill: "#E5E3EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.88c1bbe8b2706a1df984ebf28c39860a.svg";
export { ForwardRef as ReactComponent };